import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '../user-service/user.service';

/**
 * When true, the portfolio uses the full project collection (Firestore still hides `personal` from non-admins).
 * Hidden projects are visible to any authenticated user; personal projects only appear for admins.
 */
@Injectable({
  providedIn: 'root'
})
export class ViewerSessionService {
  private readonly userService = inject(UserService);

  readonly canSeeHiddenProjects$: Observable<boolean> = this.userService.isAuthenticated$;
}
